import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconNumbers.tsx
const OutlinedFilledNumbers = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z" })
});
const OutlinedNumbers = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z" })
});
const RoundedFilledNumbers = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m352-302-34 133q-4 15-16.5 25T274-134q-23 0-37-17.5t-8-40.5l28-110H154q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l42-168H220q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T468-769l-27 111h168l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T730-769l-27 111h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T806-564H680l-43 168h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T740-302H614l-34 133q-4 15-16.5 25T536-134q-23 0-37-17.5t-8-40.5l28-110H352Zm23-94h168l42-168H418l-43 168Z" })
});
const RoundedNumbers = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m352-302-34 133q-4 15-16.5 25T274-134q-23 0-37-17.5t-8-40.5l28-110H154q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l42-168H220q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T468-769l-27 111h168l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T730-769l-27 111h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T806-564H680l-43 168h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T740-302H614l-34 133q-4 15-16.5 25T536-134q-23 0-37-17.5t-8-40.5l28-110H352Zm23-94h168l42-168H418l-43 168Z" })
});
const SharpFilledNumbers = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z" })
});
const SharpNumbers = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z" })
});
const componentMap = {
	outlined: OutlinedNumbers,
	"outlined-fill": OutlinedFilledNumbers,
	rounded: RoundedNumbers,
	"rounded-fill": RoundedFilledNumbers,
	sharp: SharpNumbers,
	"sharp-fill": SharpFilledNumbers
};
const IconNumbers = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconNumbers };